import { ViewType } from './side-panel/SidePanel';

interface ViewSelectorProps {
  title: string;
  icon?: any;
  view: ViewType;
  isSelected: boolean;
  handleViewSelection: (view: ViewType) => void;
  children: any;
}

export const ViewSelector = ({
  view,
  isSelected,
  handleViewSelection,
  children
}: ViewSelectorProps) => {
  return (
    <button
      className={
        'flex-grow underline-effect ' +
        (isSelected ? 'border-b border-black' : 'border-none')
      }
      onClick={() => handleViewSelection(view)}
    >
      <div className="py-2">
        {children}
        {/* <FontAwesomeIcon
          className="text-brand-900 dark:text-neutral-100"
          icon={icon}
          size="lg"
        /> */}
      </div>
    </button>
  );
};
